import { render, staticRenderFns } from "./sub_alfx.vue?vue&type=template&id=f5cbd80e&scoped=true"
import script from "./sub_alfx.vue?vue&type=script&lang=js"
export * from "./sub_alfx.vue?vue&type=script&lang=js"
import style0 from "./sub_alfx.vue?vue&type=style&index=0&id=f5cbd80e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5cbd80e",
  null
  
)

export default component.exports